const BASE_URL = process.env.REACT_APP_BASE_URL;

export async function simulateRun(requestData, headers, setErrorMessage) {
  const simulate_url = `${BASE_URL}/simulate?storage_account=${encodeURIComponent(requestData.storage_account)}`;

  const response = await fetch(simulate_url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-User-ID": sessionStorage.getItem("UserID") || "",
      ...headers,
    },
    body: JSON.stringify(requestData),
  });

  if (!response.ok) {
    let errorMsg = response.statusText;
    const contentType = response.headers.get("Content-Type");
    if (contentType && contentType.includes("application/json")) {
      const errorData = await response.json();
      errorMsg = errorData.message || JSON.stringify(errorData);
    }
    const msg = `Simulation '${requestData.storage_account}/${requestData.microgrid_name}' failed: ${errorMsg} (HTTP ${response.status})`;
    console.error("simulateRun:", msg);
    setErrorMessage(msg);
    throw new Error(msg);
  }
}
